/*
 *
 * Children reducer
 *
 */

export const Types = {
  // Obtem catergorias
  GET_REQUEST: 'children/GET_REQUEST',
  GET_SUCCESS: 'children/GET_SUCCESS',
  GET_FAILURE: 'children/GET_FAILURE',

  // Obtem catergorias
  GET_LIST_REQUEST: 'children/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'children/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'children/GET_LIST_FAILURE',

  // Insere uma catergoria
  GET_INSERT_REQUEST: 'children/GET_INSERT_REQUEST',
  GET_INSERT_SUCCESS: 'children/GET_INSERT_SUCCESS',
  GET_INSERT_FAILURE: 'children/GET_INSERT_FAILURE',

  // Atualiza uma catergoria
  GET_UPDATE_REQUEST: 'children/GET_UPDATE_REQUEST',
  GET_UPDATE_SUCCESS: 'children/GET_UPDATE_SUCCESS',
  GET_UPDATE_FAILURE: 'children/GET_UPDATE_FAILURE',

  // Deleta uma catergoria
  GET_DELETE_REQUEST: 'children/GET_DELETE_REQUEST',
  GET_DELETE_SUCCESS: 'children/GET_DELETE_SUCCESS',
  GET_DELETE_FAILURE: 'children/GET_DELETE_FAILURE',
};

export const initialState = {
  // Categoria por id
  children: {},
  childrenLoading: false,
  childrenError: null,
  // Lista de categorias
  childrenList: [],
  childrenListLoading: false,
  childrenListError: null,
  childrenListTotal: 0,
  // Insere uma categoria
  childrenInsertLoading: false,
  childrenInsertError: false,
  // Atualiza uma categoria
  childrenUpdateLoading: false,
  childrenUpdateError: false,
  // Deleta categoria
  childrenDeleteLoading: false,
  childrenDeleteError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // Categoria por id
    case Types.GET_REQUEST:
      return {
        ...state,
        children: {},
        childrenError: null,
        childrenLoading: true,
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        children: action.payload.data,
        childrenLoading: false,
        childrenError: null,
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        childrenLoading: false,
        childrenError: action.payload,
      };
    // Lista de categorias
    case Types.GET_LIST_REQUEST:
      return { ...state, childrenListLoading: true };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        childrenList: action.payload.data,
        childrenListLoading: false,
        childrenListError: null,
        childrenListTotal: action.payload.total,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        childrenListLoading: false,
        childrenListError: action.payload,
      };
    case Types.GET_INSERT_REQUEST:
      return {
        ...state,
        childrenInsertLoading: true,
        childrenInsertError: null,
      };
    case Types.GET_INSERT_SUCCESS:
      return {
        ...state,
        childrenInsertLoading: false,
        childrenInsertError: null,
      };
    case Types.GET_INSERT_FAILURE:
      return {
        ...state,
        childrenInsertLoading: false,
        childrenInsertError: action.payload,
      };
    // Atualiza um categoria
    case Types.GET_UPDATE_REQUEST:
      return {
        ...state,
        childrenUpdateLoading: true,
        childrenUpdateError: null,
      };
    case Types.GET_UPDATE_SUCCESS:
      return {
        ...state,
        childrenUpdateLoading: false,
        childrenUpdateError: null,
      };
    case Types.GET_UPDATE_FAILURE:
      return {
        ...state,
        childrenUpdateLoading: false,
        childrenUpdateError: action.payload,
      };
    // Deleta uma categoria
    case Types.GET_DELETE_REQUEST:
      return {
        ...state,
        childrenDeleteLoading: true,
        childrenDeleteError: null,
      };
    case Types.GET_DELETE_SUCCESS:
      return {
        ...state,
        childrenDeleteLoading: false,
        childrenDeleteError: null,
      };
    case Types.GET_DELETE_FAILURE:
      return {
        ...state,
        childrenDeleteLoading: false,
        childrenDeleteError: action.payload,
      };
    default:
      return state;
  }
};

export const Creators = {
  // Busca uma categoria
  getChildrenRequest: ({ id }) => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),
  getChildrenSuccess: ({ data }) => ({
    type: Types.GET_SUCCESS,
    payload: { data },
  }),
  getChildrenFailure: error => ({
    type: Types.GET_FAILURE,
    payload: error,
  }),
  // Insere uma categoria
  getChildrenInsertRequest: ({
    email,
    password,
    name,
    cpf,
    genre,
    description,
    cell_phone,
    store,
    group,
    address,
    image_data,
  }) => ({
    type: Types.GET_INSERT_REQUEST,
    payload: {
      email,
      password,
      name,
      cpf,
      genre,
      description,
      cell_phone,
      store,
      group,
      address,
      image_data,
    },
  }),
  getChildrenInsertSuccess: () => ({
    type: Types.GET_INSERT_SUCCESS,
  }),
  getChildrenInsertFailure: error => ({
    type: Types.GET_INSERT_FAILURE,
    payload: error,
  }),
  // Busca lista de categorias
  getChildrenListRequest: ({
    page,
    perPage,
    search,
    orderByColumn,
    orderByDirection,
    group_id,
  }) => ({
    type: Types.GET_LIST_REQUEST,
    payload: {
      page,
      perPage,
      search,
      orderByColumn,
      orderByDirection,
      group_id,
    },
  }),
  getChildrenListSuccess: ({ data, total }) => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { data, total },
  }),
  getChildrenListFailure: error => ({
    type: Types.GET_LIST_FAILURE,
    payload: error,
  }),
  // Atualiza uma  Categoria
  // Insere uma categoria
  getChildrenUpdateRequest: ({
    id,
    email,
    password,
    name,
    cpf,
    genre,
    description,
    cell_phone,
    birth_date,
    store,
    group,
    address,
    image_data,
  }) => ({
    type: Types.GET_UPDATE_REQUEST,
    payload: {
      id,
      email,
      password,
      name,
      cpf,
      store,
      genre,
      description,
      cell_phone,
      birth_date,
      group,
      address,
      image_data,
    },
  }),
  getChildrenUpdateSuccess: () => ({
    type: Types.GET_UPDATE_SUCCESS,
  }),
  getChildrenUpdateFailure: error => ({
    type: Types.GET_UPDATE_FAILURE,
    payload: error,
  }),
  // Deleta uma categoria
  getChildrenDeleteRequest: id => ({
    type: Types.GET_DELETE_REQUEST,
    payload: { id },
  }),
  getChildrenDeleteSuccess: () => ({
    type: Types.GET_DELETE_SUCCESS,
  }),
  getChildrenDeleteFailure: error => ({
    type: Types.GET_DELETE_FAILURE,
    payload: error,
  }),
};
